import { render, staticRenderFns } from "./pairItem.vue?vue&type=template&id=2e3e7631&"
import script from "./pairItem.vue?vue&type=script&lang=js&"
export * from "./pairItem.vue?vue&type=script&lang=js&"
import style0 from "./pairItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3e7631')) {
      api.createRecord('2e3e7631', component.options)
    } else {
      api.reload('2e3e7631', component.options)
    }
    module.hot.accept("./pairItem.vue?vue&type=template&id=2e3e7631&", function () {
      api.rerender('2e3e7631', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/trust/dialog/pairItem.vue"
export default component.exports